module.exports = __webpack_public_path__ + "img/ext11.5d5ac661.jpg";